import React from "react";
import styled from "styled-components";
import { Row, Col, Card, Form, Button, Stack } from "react-bootstrap";
import Table from "./Table";
import { useState, useMemo } from "react";
import Pagination from "../../../organisms/Pagination";
import TableTitle from "../../../organisms/TableTitle";
import { ItemListadoProductos } from "../../../../services/productosServicios";
import IconContainer from "../../../organisms/IconContainer";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { DetalleProducto } from "../Model";
import { filterByStringIgnoreCase } from "../../../../utils/tableUtils";

function TableSection({
  title,
  items,
  onProductoCantidadChange,
  detallesPorProducto,
  isLoading,
  isSuccess,
  onCarritoClick,
}: {
  title: string;
  items: ItemListadoProductos[];
  onProductoCantidadChange: (
    idProducto: string,
    nombre: string,
    cant: string,
    valor: number
  ) => void;
  detallesPorProducto: Map<string, DetalleProducto>;
  onCarritoClick: () => void;
  isLoading: boolean;
  isSuccess: boolean;
}) {
  const [filtro, setFiltro] = useState("");
  const [finalFilter, setFinalFilter] = useState("");
  const [activePageNumber, setActivePageNumber] = useState(1);
  const [itemsToShow, setItemsToShow] = useState(10);

  const onBuscar = (newFilter: string) => setFinalFilter(newFilter);

  const itemsFiltrados = useMemo(
    () => filterByStringIgnoreCase(items, finalFilter),
    [items, finalFilter]
  );
  const page = useMemo(
    () => generatePage(itemsFiltrados, activePageNumber, itemsToShow),
    [itemsFiltrados, activePageNumber, itemsToShow]
  );

  return (
    <Row>
      <Col className="col-12">
        <StyledCard>
          <StyledCardHeader className="d-flex">
            <TableTitle>{title}</TableTitle>
            <Button onClick={onCarritoClick}>
              <IconContainer style={{ color: "white" }}>
                <ShoppingCartIcon />
              </IconContainer>
            </Button>
          </StyledCardHeader>
          <StyledCardBody>
            <ResponsiveTableSection>
              <TableWrapper>
                <Stack gap={4}>
                  <TableLengthSection>
                    <Form>
                      <StyledFormGroup as={Row}>
                        <Form.Label column sm="auto">
                          Items:
                        </Form.Label>
                        <Col sm="auto">
                          <StyledFormSelect
                            value={itemsToShow}
                            onChange={(
                              e: React.ChangeEvent<HTMLSelectElement>
                            ) => setItemsToShow(parseInt(e.target.value))}
                          >
                            {[5, 10, 15].map((pageSize, index) => (
                              <option key={index} value={pageSize}>
                                {pageSize}
                              </option>
                            ))}
                          </StyledFormSelect>
                        </Col>
                        <Form.Label column sm="auto">
                          Filtro:
                        </Form.Label>
                        <Col sm="auto">
                          <StyledFormControl
                            type="text"
                            value={filtro}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => setFiltro(e.target.value)}
                          />
                        </Col>
                        <Col sm="auto">
                          <Button
                            variant="primary"
                            onClick={() => onBuscar(filtro)}
                          >
                            Buscar
                          </Button>
                        </Col>
                      </StyledFormGroup>
                    </Form>
                  </TableLengthSection>
                  <Table
                    mascotas={page}
                    onProductoCantidadChange={onProductoCantidadChange}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                    detallesPorProducto={detallesPorProducto}
                  />
                  <div>
                    <Pagination
                      pageSize={itemsToShow}
                      setActivePageNumber={setActivePageNumber}
                      activePageNumber={activePageNumber}
                      rows={itemsFiltrados}
                    />
                  </div>
                </Stack>
              </TableWrapper>
            </ResponsiveTableSection>
          </StyledCardBody>
        </StyledCard>
      </Col>
    </Row>
  );
}

function generatePage(
  rows: Array<any>,
  pageNumber: number,
  pageSize: number
): Array<any> {
  const end = pageNumber * pageSize;
  const start = end - pageSize;
  return rows.slice(start, end);
}

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background: transparent;
  padding: 1.25rem 1.25rem 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0px;
`;

const StyledCardBody = styled(Card.Body)`
  padding: 1.25rem;
`;
const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

const TableLengthSection = styled("div")`
  float: left;
`;

const StyledFormGroup = styled(Form.Group)`
  justify-content: start;
`;
const StyledFormControl = styled(Form.Control)`
  &:focus {
    box-shadow: none;
  }
`;

const StyledFormSelect = styled(Form.Select)`
  &:focus {
    box-shadow: none;
  }
`;

export default TableSection;
